// 订单状态
export const DATA_ORDER_STATUS = {
    '6': {
        text: '已付款'
    },
    '7': {
        text: '已付款'
    },
    '8': {
        text: '已结算'
    },
    '9': {
        text: '已结算'
    },
    '11': {
        text: '已结算'
    },
    '12': {
        text: '已失效'
    },
    '10': {
        text: '已退款'
    },
    '13': {
        text: '已退款'
    },
    '-5': {
        text: '待付款'
    },
    '0': {
        text: '未成团'
    }
}
// 订单返利状态
export const DATA_ORDER_FANLI_STATUS = {
    '0': {
        text: '未返利'
    },
    '1': {
        text: '已返利'
    },
    '2': {
        text: '已退款'
    },
    'Null': {
        text: '默认'
    }
}